module.exports = __webpack_public_path__ + "img/fixedaccount.e3e81fb9.svg";